/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { Typography } from '@material-ui/core';
import useStyles from './styles';

const Footer = () => {
  const classes = useStyles();

  return (
    <div className={classes.sectionFooter}>
      <Container maxWidth="lg">
        <Box className={classes.footer}>
          <Box className={classes.caj}>
            <img src="assets/images/logo_caj.png" alt="CAJ Logo" className={classes.footerLogo} />
          </Box>
          <Box className={classes.qlikCopy}>
            <a href="https://www.qlik.com/us/"><img src="assets/images/powered-byqlik-vertical.png" alt="Qlik Logo" className={classes.footerQlikLogo} /></a>
            <Typography variant="body1" className={classes.copy}>© 1993-2022 QlikTech International AB, All Rights Reserved</Typography>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default Footer;
